import { useState, useEffect } from 'react';
import { MOCK_INCIDENTS, MOCK_ZONES } from './mockData.js';

const API_URL = (import.meta.env.VITE_WAR_RISK_WORKER_URL || 'http://localhost:8788').replace(/\/$/, '');

// Normalize an incident from either the old UKMTO schema or new RSS schema
// so every downstream component can rely on a consistent field set.
function normalizeIncident(inc) {
  return {
    ...inc,
    date:          inc.date          || inc.published,
    zone:          inc.zone          || inc.zone_name,
    advisory_text: inc.advisory_text || inc.summary || '',
    type:          inc.type          || 'incident',
    position:      inc.position      || null,
    // RSS-specific fields — may be absent on mock data
    primary_source:  inc.primary_source  || null,
    also_covered_by: inc.also_covered_by || [],
    matched_keywords: inc.matched_keywords || [],
  };
}

async function fetchWarRiskData() {
  try {
    const [iRes, zRes] = await Promise.all([
      fetch(`${API_URL}/api/war-risk/incidents?days=30`),
      fetch(`${API_URL}/api/war-risk/zones`),
    ]);
    if (!iRes.ok || !zRes.ok) throw new Error(`Worker responded ${iRes.status}/${zRes.status}`);
    const [iData, zData] = await Promise.all([iRes.json(), zRes.json()]);
    return {
      ...iData,
      incidents: (iData.incidents || []).map(normalizeIncident),
      zones:     zData.zones,
      source:    'live',
      _fetchError: null,
    };
  } catch (err) {
    console.warn(`[WarRisk] Live fetch failed (${err.message}), using demo data`);
    return {
      ...MOCK_INCIDENTS,
      incidents: (MOCK_INCIDENTS.incidents || []).map(normalizeIncident),
      zones:     MOCK_ZONES.zones,
      source:    'mock',
      _fetchError: err.message,
    };
  }
}

export default function useWarRiskData() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWarRiskData()
      .then(d => { setData(d); setLoading(false); })
      .catch(err => {
        console.error('[WarRisk] unexpected error:', err);
        setData({
          ...MOCK_INCIDENTS,
          incidents: (MOCK_INCIDENTS.incidents || []).map(normalizeIncident),
          zones: MOCK_ZONES.zones,
          source: 'mock',
          _fetchError: String(err),
        });
        setLoading(false);
      });
  }, []);

  return { data, loading };
}
